import reducer from "./reducer";
export { default as assetsAndDiscountsScreenSelector } from "./components/index";
export { default as assetsDiscountsScreenSelectorReducerName } from "./constants";
export default reducer;
